import React from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

import Body from './Body';
import Head, { Props } from './Head';

const CREATE_KEY = 'CREATE';
const DELETE_KEY = 'DELETE';

const Changeset: React.FC<Props> = (props) => (
  <Box
    pad="spacing24"
    background="module"
    round="container1Round"
    data-testid={`ActivityLog_changeset_${props.id}`}
  >
    <Box>
      <Head {...props} />

      <Box margin={{ top: 'spacing12' }}>
        <Box
          data-testid={`ActivityLog_changeset_${props.id}_header`}
          height="32px"
          background="legend"
          round="fieldRound"
          pad={{ vertical: '7px', horizontal: 'spacing12' }}
          direction="row"
          align="center"
        >
          <Box width="26%" data-testid={`ActivityLog_changeset_${props.id}_column_attribute`}>
            <Inscription size="12px" weight="bold">
              Attribute
            </Inscription>
          </Box>
          {props.isTwoColumnMode && (props.type === CREATE_KEY || props.type === DELETE_KEY) ? (
            <Box
              width="37%"
              pad={{ left: 'spacing24' }}
              data-testid={`ActivityLog_changeset_${props.id}_column_value`}
            >
              <Inscription size="12px" weight="bold">
                Value
              </Inscription>
            </Box>
          ) : (
            <>
              <Box
                width="37%"
                pad={{ left: 'spacing24' }}
                data-testid={`ActivityLog_changeset_${props.id}_column_previous`}
              >
                <Inscription size="12px" weight="bold">
                  Previous
                </Inscription>
              </Box>
              <Box
                width="37%"
                pad={{ left: '36px' }}
                data-testid={`ActivityLog_changeset_${props.id}_column_updated`}
              >
                <Inscription size="12px" weight="bold">
                  Updated
                </Inscription>
              </Box>
            </>
          )}
        </Box>
      </Box>

      <Body id={props.id} isTwoColumnMode={props.isTwoColumnMode} type={props.type} />
    </Box>
  </Box>
);

export default Changeset;
